import React, {useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import PercentIcon from '@mui/icons-material/Percent';

import {EditIcon} from "../common/icons";
import COLOR_THEMES from "../../colorThemes";
import TextInput from "../ui/textInput";
import {setManualTax} from "../../actions/shoppingCartFunctions";
import {getPriceWithCurrency} from "../../misc/helpers";
import {setFabricatorTaxes} from "../../actions/actionFunctions";


const MAX_TAX = 999999;


const ShoppingCartTaxInput = (props) => {

  const {setManualTax, activeTheme, fabricatorSettings, sureTax, taxTotal, manualTaxEntered, taxObject, fabricatorTaxes,
    setFabricatorTaxes} = props;

  const isTaxObject = taxObject && taxObject.isCustomEditableTax;

  const [priceEditing, setPriceEditing] = useState(false);
  const [priceValue, setPriceValue] = useState(isTaxObject ? taxObject.materialRate || "" : 0);

  const togglePriceEditing = () => {
    if (priceEditing && isTaxObject) {
      setFabricatorTaxes(fabricatorTaxes.map(tax => {
        if (tax.id === taxObject.id) {
          tax.materialRate = priceValue;
        }
        return tax;
      }));
    }
    setPriceEditing(!priceEditing);
  };

  // if (selectionFeatureInfo && selectionFeatureInfo.dbFeature.id && document.kvConfig.isBackend) {
  //   return <FeatureInfoPriceInput/>
  // }

  const handlePriceOnChange = (newAmount) => {
    if (isTaxObject) {
      setPriceValue(newAmount > 100 ? 100 : newAmount);
      return
    }
    setManualTax(newAmount > MAX_TAX ? MAX_TAX : newAmount);
  }

  return (
    <div className="product-info__edit flex--end">
      <TextInput className={"ui-input ui-input--new product-info__edit-input"
        + (priceEditing ? " product-info__edit-input--visible" : "")
        + (isTaxObject ? " pl-05 pr-05 w-4 ui-input--percentage" : "")}
                 numberInput={true}
                 autoComplete={"off"}
                 id="product-info-input"
                 onChange={handlePriceOnChange}
                 onBlur={togglePriceEditing}
                 onRealChange={handlePriceOnChange}
                 usePropsValue={isTaxObject}
                 value={isTaxObject ? priceValue : sureTax}/>
      {priceEditing && isTaxObject ? <PercentIcon className="color-active"/> : null}
      {priceEditing || (taxObject.isCustomEditableTax && !taxObject.materialRate) ? null : (
        <p className="dcart-column__value">
          {getPriceWithCurrency(fabricatorSettings, manualTaxEntered ? sureTax : taxTotal)}
        </p>
      )}
      <label htmlFor="product-info-input" className="product-info__edit-icon" onClick={togglePriceEditing}>
        <EditIcon color={COLOR_THEMES[activeTheme].active}/>
      </label>
    </div>
  )
};

ShoppingCartTaxInput.propTypes = {
  onBlur: PropTypes.func,
  taxTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  taxObject: PropTypes.object,
};

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {sureTax, manualTaxEntered} = store.cartState;
  const {fabricatorTaxes} = store.fabricatorState;

  return {
    fabricatorSettings: store.fabricatorState.settings,
    sureTax,
    manualTaxEntered,
    activeTheme,
    fabricatorTaxes,
  };
};

const mapDispatchToProps = {
  setManualTax,
  setFabricatorTaxes,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartTaxInput)
);
